import React, { Fragment } from 'react'
import AudioGuidePlayerContext from '../../../contexts/AudioGuidePlayerContext'
import { secondsToMinutes, getFeaturedImageUrl } from '../../../services/service-utils'
import Svg from '../../Svg/Svg'
import { Icon } from "../../../constants/consts-types"
import styles from './AudioGuideEpisode.css'

function AudioGuideEpisode({ audioGuideName, 
  audioEpisode = {},
  artwork = {}, 
  colors, 
  language,
  handleOpenMap
 }) {
  const episodeTitle = (audioEpisode && audioEpisode.title && audioEpisode.title.rendered) || ''
  
  // Image URL
  const source_url = audioEpisode._embedded && audioEpisode._embedded['wp:featuredmedia'][0] 
                      && getFeaturedImageUrl(audioEpisode)

  const { audio_file, description, episode_duration } = audioEpisode.acf || {}

  const subHeader = `
    ${(artwork.production && artwork.production[0] && artwork.production[0].creator + ' | ') || ''}
    ${(artwork.titles && artwork.titles[0] && artwork.titles[0].title + ', ') || ''}
    ${(artwork.production_date && artwork.production_date[0] && artwork.production_date[0].period) || ''}
  `

  return (
    <div className={styles.episodeItem}>
      <div className={`${styles.episodeItemImage}`}>
        <img alt="" src={source_url} />
      </div>

      <div className={styles.episodeItemTextArea}>
        <div className={`row ${styles.HeadphoneRow}`}>
          <div>
            <Svg id={Icon.GUIDE_HEADSET} className={styles.episodeIcon} />
            {/* <img src="https://img.icons8.com/ios/50/000000/headphones.png" alt="" /> */}
          </div>
          <div>
            <button 
              onClick={() => handleOpenMap(artwork)}
              className={styles.showMapButton}
            >
              <div className={styles.showMapButtonInnerContent}>
                {artwork.current_location_name}
              </div>
              
            </button>
          </div>
        </div>
        <Fragment>
          <div className={styles.header} dangerouslySetInnerHTML={{ __html: episodeTitle }} />
          {description && (
            <p className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
          )}
          {subHeader && (
            <p className={styles.subHeader}>
              {subHeader}
            </p>
          )}
          <div className={`row ${styles.playEpisode}`}>
            <AudioGuidePlayerContext.Consumer>
              {({ setData }) => (
                <button
                  type="button"
                  aria-label={`Play: ${episodeTitle}`}
                  disabled={!audio_file}
                  className={styles.circle}
                  style={{ backgroundColor: colors.background }}
                  onClick={() => setData(audioGuideName, episodeTitle, audio_file)}
                >
                  <Svg id={Icon.PLAY2} style={{ fill: colors.foreground }}/>
                </button>
              )}
            </AudioGuidePlayerContext.Consumer>
            <div>
              {episode_duration && secondsToMinutes(episode_duration)} min
            </div>
          </div>
        </Fragment>
      </div>
    </div>
  )
}

export default AudioGuideEpisode





// WEBPACK FOOTER //
// ./src/components/AudioGuideComponents/AudioGuideEpisode/AudioGuideEpisode.js